/* VietMeet Meet app main entrypoint. */
// Re-export jQuery
// FIXME: Remove this requirement from torture tests.
// @ts-ignore
import $ from 'jquery';
// @ts-ignore
window.$ = window.jQuery = $;
import '@matrix-org/olm';
import 'focus-visible';
/*
* Safari polyfill for createImageBitmap
* https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/createImageBitmap
*
* Support source image types: Canvas.
*/
if (!('createImageBitmap' in window)) {
    // @ts-ignore
    window.createImageBitmap = function (data) {
        return new Promise((resolve, reject) => {
            let dataURL;
            if (data instanceof HTMLCanvasElement) {
                dataURL = data.toDataURL();
            }
            else {
                reject(new Error('createImageBitmap does not handle the provided image source type'));
            }
            const img = document.createElement('img');
            img.addEventListener('load', () => {
                resolve(img);
            });
            // @ts-ignore
            img.src = dataURL;
        });
    };
}
// We need to setup the vietmeet-local-storage as early as possible so that we can start using it.
// NOTE: If vietmeet-local-storage is used before the initial setup is performed this will break the use case when we use
// the  local storage from the parent page when the localStorage is disabled. Also the setup is relying that
// window.location is not changed and still has all URL parameters.
import './react/features/base/vietmeet-local-storage/setup';
import conference from './conference';
import API from './modules/API';
import UI from './modules/UI/UI';
import translation from './modules/translation/translation';
// Initialize Olm as early as possible.
if (window.Olm) {
    window.Olm.init().catch(e => {
        console.error('Failed to initialize Olm, E2EE will be disabled', e);
        // @ts-ignore
        delete window.Olm;
    });
}
// @ts-ignore
window.APP = {
    API,
    conference,
    translation,
    UI
};
// TODO The execution of the mobile app starts from react/index.native.js.
// Similarly, the execution of the Web app should start from react/index.web.js
// for the sake of consistency and ease of understanding. Temporarily though
// because we are at the beginning of introducing React into the Web app, allow
// the execution of the Web app to start from app.js in order to reduce the
// complexity of the beginning step.
import './react';
// Let users / forks implement custom JS logic that gets bundled.
// Uses webpackMode: 'eager' so it is evaluates as part of the next microtask.
// @ts-ignore
import(/* webpackMode: 'eager' */ './custom.js');
